import { createFileRoute, Link } from "@tanstack/react-router";
import { Logo } from "@/components/logo";
import { SampleIRRDocument } from "@/components/marketing/sample-irr-document";
import { LegalFooter } from "@/components/marketing/legal-page";
import { SampleBanner } from "@/components/marketing/sample-banner";

export const Route = createFileRoute("/sample-report")({
  head: () => ({
    meta: [
      { title: "Sample: Investor Readiness Report | CapitalDart" },
      {
        name: "description",
        content:
          "A sample of CapitalDart's Investor Readiness Report using fictional demonstration data. CapitalDart matches companies raising capital with institutional investors.",
      },
      {
        property: "og:description",
        content:
          "A sample of CapitalDart's Investor Readiness Report using fictional demonstration data. CapitalDart matches companies raising capital with institutional investors.",
      },
      {
        name: "twitter:description",
        content:
          "A sample of CapitalDart's Investor Readiness Report using fictional demonstration data. CapitalDart matches companies raising capital with institutional investors.",
      },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: SampleReportPage,
});

function SampleReportPage() {
  return (
    <main className="min-h-screen bg-brand-paper-2 px-4 py-12 sm:py-16">
      <article className="relative mx-auto max-w-[820px] overflow-hidden rounded-2xl border border-brand-line bg-brand-paper shadow-[0_1px_0_var(--brand-line),0_30px_60px_-30px_oklch(0.264_0.068_255.3/0.18)]">
        <nav className="flex items-center justify-between border-b border-brand-line px-[22px] py-4 lg:px-10">
          <Link to="/" className="flex items-center gap-2 text-brand-ink no-underline">
            <Logo
              src="/capitaldart-logo.png"
              alt="CapitalDart"
              className="h-9 w-auto"
              height={36}
              trademarkClassName="text-brand-ink"
            />
          </Link>
          <Link to="/" className="text-[12.5px] text-brand-muted no-underline hover:text-brand-ink">
            ← Back to capitaldart.com
          </Link>
        </nav>
        <SampleBanner />
        <SampleIRRDocument />
        <LegalFooter />
      </article>
    </main>
  );
}
